import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './en.json';
import frTranslation from './fr.json';
import esTranslation from './es.json';
import deTranslation from './de.json';
import ptTranslation from './pt.json';

i18n
  .use(LanguageDetector) // Use the language detector
  .use(initReactI18next) // Initialize react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      es: {
        translation: esTranslation,
      },
      de: {
        translation: deTranslation,
      },
      pt: {
        translation: ptTranslation,
      },
    },
    fallbackLng: 'en', // Fallback language if detection fails
    detection: {
      // Configure how language detection should work
      order: [
        'navigator',
        'localStorage',
        'htmlTag',
        'path',
        'subdomain',
      ], // Order of detection methods
      caches: ['localStorage'], // Cache the language in localStorage
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
